import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { Stack, Box, Card, CardActions, CardContent, CardHeader, Grid, Chip } from '@mui/material';
import { styled } from '@mui/styles';
import { isEmpty } from 'lodash-es';
import { ReactElement, useState } from 'react';
import { GrDocumentUpdate, GrLocation } from 'react-icons/gr';
import { TbEyeCheck } from 'react-icons/tb';
import {
  ChipsType,
  timeSince,
  WsButton,
  WsColors,
  WsIconText,
  WsIconViewJD,
  WsTagsList,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  ActiveJob,
} from 'wisestep-base';

import CandidateAvatar from '../candidateAvatar/CandidateAvatar';
interface SearchResultsCardProps {
  candidateId: string;
  title: string;
  imgSrc?: string;
  isDownloaded: boolean;
  showRelevance?: boolean;
  relevance?: string;
  isViewCv?: boolean;
  name: string;
  skills: string[];
  profileDescription?: string;
  onViewCvClick: (candidateId: string) => Promise<void>;
  onViewDetailsClick?: (candidateId: string) => Promise<void>;
  dateLastActive?: string;
  dateResumeLastUpdated?: string;
  viewCvLabel?: string;
  dateCreated?: string;
  IsAnonymous?: boolean;
  skillsDisplayCount?: number;
}

export type ChipPropsType = {
  isPointer?: boolean;
  borderRadius?: number;
  textColor?: string;
  fontSize?: string;
  background?: string;
};
export const StyledChip = styled(Chip)(
  ({ isPointer, borderRadius = 4, textColor, background, fontSize }: ChipPropsType) => ({
    color: textColor,
    borderRadius: borderRadius,
    fontSize: fontSize,
    marginRight: 5,
    background: background,
    fontWeight: 700,
    ...(isPointer && { cursor: 'pointer' }),
  })
);
const SearchResultsCard = ({
  candidateId,
  title,
  imgSrc = '',
  isDownloaded = false,
  showRelevance = false,
  relevance = '',
  isViewCv = true,
  name,
  skills,
  onViewCvClick,
  onViewDetailsClick = async () => {
    await new Promise<void>((resolve) => resolve());
  },
  dateLastActive,
  viewCvLabel = 'View CV',
  dateResumeLastUpdated,
  dateCreated,
  IsAnonymous = false,
  skillsDisplayCount = 24,
}: SearchResultsCardProps) => {
  const searchQuery = '';
  const [isResumeDownloaded, setIsDownloaded] = useState<boolean>(isDownloaded);
  const [hideDetails, setHideDetails] = useState<boolean>(isDownloaded);
  const [handleViewCvClick, setHandleViewCvClick] = useState(false);
  const onViewCV = async () => {
    setHandleViewCvClick(true);
    await onViewCvClick(candidateId);
    if (!isDownloaded && !isResumeDownloaded) {
      //   setUpdateJBViews(true);
    }
    setIsDownloaded(true);
    setHandleViewCvClick(false);
  };
  return (
    <Card>
      <CardHeader
        avatar={<CandidateAvatar name={name} src={imgSrc} />}
        sx={{ paddingBottom: 0 }}
        title={
          <Grid container display="flex" justifyContent="space-between">
            <Grid item xs={6} display="flex" columnGap={2} alignItems="center">
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
                {title}
              </WsTypography>
              <Stack direction="row" alignItems={'center'}>
                {showRelevance ? (
                  <StyledChip
                    icon={<></>}
                    label={relevance}
                    borderRadius={20}
                    background={WsColors.BackGroundGreen}
                    textColor={WsColors.White}
                    fontSize="12px"
                  />
                ) : (
                  <></>
                )}
                {isResumeDownloaded ? (
                  <StyledChip
                    icon={<TbEyeCheck size="16px" color={WsColors.TheBlues500} />}
                    label={'Viewed'}
                    background={WsColors.TheBlues100}
                    textColor={WsColors.TheBlues500}
                    fontSize="12px"
                  />
                ) : (
                  <></>
                )}
              </Stack>
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Grid container display="flex" justifyContent="flex-end">
                <Grid item display="flex" justifyContent="center">
                  {dateCreated && (
                    <WsIconText
                      icon={<GrDocumentUpdate />}
                      text={`Profile created ${timeSince(dateCreated)}`}
                      popOverText={'Profile created On: ' + dateCreated}
                      textSize={WsTypoVariants.BODY1}
                    />
                  )}
                  {dateLastActive && (
                    <WsIconText
                      icon={<GrDocumentUpdate />}
                      text={`Last Active ${timeSince(dateLastActive)}`}
                      popOverText={'Last Active On: ' + dateLastActive}
                      textSize={WsTypoVariants.BODY1}
                    />
                  )}
                  {dateResumeLastUpdated && (
                    <WsIconText
                      icon={<GrDocumentUpdate />}
                      text={`Resume Updated ${timeSince(dateResumeLastUpdated)}`}
                      popOverText={'Resume Updated On: ' + dateResumeLastUpdated}
                      textSize={WsTypoVariants.BODY1}
                    />
                  )}
                </Grid>
                <Grid item>
                  {!IsAnonymous && (
                    <>
                      {isViewCv ? (
                        <WsButton
                          onClick={() => onViewCV()}
                          variant="text"
                          size="large"
                          startIcon={<WsIconViewJD />}
                          disabled={handleViewCvClick}
                        >
                          {viewCvLabel}
                        </WsButton>
                      ) : (
                        <WsButton
                          onClick={() => onViewDetailsClick(candidateId)}
                          variant="text"
                          size="large"
                          startIcon={<WsIconViewJD />}
                        >
                          View details
                        </WsButton>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        <Grid container spacing={1} px={2}>
          <Grid item xs={4} rowSpacing={1}>
            <Grid item xs={12} display="flex" columnSpacing={4} pl={4}>
              <Details
                icon={
                  <ActiveJob
                    color={WsColors.TertiaryShades500}
                    color2={WsColors.TertiaryShades600}
                    height={20}
                    width={21}
                  />
                }
                title={'Job Title'}
                value=" .Net Developer"
              />
            </Grid>
            <Grid item xs={12} display="flex" columnSpacing={4} pl={4}>
              <Details icon={<GrLocation />} title={'Location'} value=" New York,United States" />
            </Grid>
            <Grid item xs={12} display="flex" columnSpacing={4} pl={4}>
              <Details icon={<GrLocation />} title={'CTC'} value="$ 150,000" />
            </Grid>
            {!hideDetails && (
              <>
                <Grid item xs={12} display="flex" columnSpacing={4} pl={4}>
                  <Details icon={<GrLocation />} title={'Source'} value="LinkedIn" />
                </Grid>
                <Grid item xs={12} display="flex" columnSpacing={4} pl={4}>
                  <Details icon={<GrLocation />} title={'Experience'} value="6 years" />
                </Grid>
              </>
            )}
          </Grid>
          <Grid item xs={8} display="flex">
            {!isEmpty(skills) && (
              <>
                <Box pt={0.5} pr={0.6}>
                  <VerifiedOutlinedIcon htmlColor={WsColors.GreyBlack} />
                </Box>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={WsTypoColors.PRIMARY}
                  cursor="pointer"
                >
                  Skills :
                </WsTypography>
                <WsTagsList
                  chipArray={skills}
                  count={skillsDisplayCount}
                  type={ChipsType.SECONDARY}
                  query={searchQuery ?? ''}
                />
              </>
            )}
          </Grid>
        </Grid>
      </CardContent>
      <CardActions disableSpacing sx={{ padding: 0 }}>
        <WsButton
          onClick={() => setHideDetails(!hideDetails)}
          variant="text"
          size="large"
          endIcon={
            hideDetails ? <KeyboardArrowDownOutlinedIcon /> : <KeyboardArrowUpOutlinedIcon />
          }
          disabled={handleViewCvClick}
        >
          {hideDetails ? 'More Details' : 'Hide Details'}
        </WsButton>
      </CardActions>
    </Card>
  );
};

export default SearchResultsCard;

interface DetailsProps {
  icon: ReactElement;
  title: string;
  value: string;
}
const Details = ({ icon, title, value }: DetailsProps) => (
  <Grid container display="flex" justifyContent="space-between">
    <Grid item xs={4}>
      <WsIconText
        icon={icon}
        text={title}
        opacity={true}
        textCursor="pointer"
        textSize={WsTypoVariants.TITLE}
      />
    </Grid>
    <Grid item xs={8} display="flex" justifyContent="left">
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.GREYTEXT} cursor="pointer">
        {value}
      </WsTypography>
    </Grid>
  </Grid>
);
